// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/chunk." + {"vendors-html2canvas_dist_html2canvas_js":"c25c756768a15cf6aff0","vendors-dompurify_dist_purify_es_mjs":"ec9e7181d760436b2281","vendors-canvg_lib_index_es_js":"7f197d0ebfadaf996b23"}[chunkId] + ".js";
};